module.exports = __webpack_public_path__ + "static/media/1.c4e4ba84.webp";